import { Button, Result } from "antd";
import Cookies from "js-cookie";

import { SPS_ID } from "./constants";

function InvalidIdPage() {
  const handleCreateNewProject = () => {
    Cookies.remove(SPS_ID);
    window.location.href = "/simple-prompt-studio";
  };

  return (
    <Result
      status="404"
      title="Invalid Project ID"
      subTitle="Oops! The project ID you're trying to access doesn't seem to exist. It might have been deleted, or the ID could be incorrect."
      extra={
        <Button type="primary" onClick={handleCreateNewProject}>
          Create New Project
        </Button>
      }
    />
  );
}

export { InvalidIdPage };
